import { Link } from '../Link';

import { HelpButtonProps } from './HelpButton.interfaces';
import styles from './HelpButton.module.css';

const HelpButton = ({ className, isCompact = false, isFixed = false }: HelpButtonProps) => (
  <Link
    className={`${styles['c-help-button']} ${String(className)} ${isFixed ? styles['c-help-button__fixed'] : ''} ${
      isCompact ? styles['c-help-button--compact'] : ''
    }`}
    href="/crisis-and-support"
  >
    <div className={styles['c-help-button__icon']}>
      <img alt="Crisis support" src="/images/ctls/crisis-icon.svg" />
    </div>
    <span className={styles['c-help-button__text']}>Crisis support</span>
  </Link>
);

export { HelpButton };
